import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import { Link } from 'react-router-dom';
import Section from './Section';

const HeroSection = ({ title, navList, className }) => (
  <Section className={`${className || ''} bg bg-hero`}>
    <h1 className="mt-0 mb-3 sm:mb-5 text-white uppercase text-3xl font-bold text-center">
      {title}
    </h1>
    <Breadcrumbs
      className="text-white capitalize justify-center"
      separator="&mdash;"
    >
      {navList.map((item, index) =>
        index === navList.length - 1 ? (
          <Typography key={index} className="underline text-gray-300">
            {item}
          </Typography>
        ) : (
          <MuiLink
            key={index}
            component={Link}
            to={`/${item}`}
            underline="hover"
            className="text-white"
          >
            {item}
          </MuiLink>
        )
      )}
    </Breadcrumbs>
  </Section>
);

HeroSection.propTypes = {
  title: PropTypes.string,
  navList: PropTypes.array,
  className: PropTypes.string,
};

export default HeroSection;
